import { render, staticRenderFns } from "./Accountability.vue?vue&type=template&id=73675dde&"
import script from "./Accountability.vue?vue&type=script&lang=js&"
export * from "./Accountability.vue?vue&type=script&lang=js&"
import style0 from "./Accountability.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports